import api from "./api";
export const getPublicMakes = async () => {
  // ✅ Send an empty object to avoid undefined body
  const response = await api.post("/make/all", {});
  return response.data.data;
};